import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, IconButton} from '@material-ui/core';
import BasicButton from 'Components/common/BasicButton';
import {ArrowBackIos} from '@material-ui/icons';
import {openNotification} from 'Actions/notification';
import LoadingIcon from 'Components/icons/LoadingIcon';
import Dialog from 'Components/common/Dialog';
import {viewAllApplyList, backupAllApplyItem} from 'Actions/allApply';
import {T} from 'Actions/translate';

const getTransMode = {
    Express: T('order_self_express'),
    N: T('order_no_name'),
    Direct: T('all_apply_direct_method'),
};

const getUserType = {
    0: T('all_apply_Customer'),
    1: 'Admin',
    2: T('all_apply_Host'),
    3: T('all_apply_Sales'),
};

class AllApplyApprovalDetails extends Component {
    state = {
        onloadList: false,
        backupOpened: false,
    };

    async componentDidMount() {
        this.setState({
            onloadList: true,
        });
        const id = this.props.location.state.id;
        await this.props.viewAllApplyList(id).then((res) => {
            if (res.status === 'success') {
                this.setState({
                    onloadList: false,
                });
            }
        });
    }

    backupApply = () => {
        this.setState({
            backupOpened: true,
        });
    };

    closeDialog = () => {
        this.setState({
            backupOpened: false,
        });
    };

    cancelApply = () => {
        this.setState({
            onloadList: true,
        });
        const id = this.props.location.state.id;
        const onlyLookMe = this.props.location.state.onlyLookMe;
        this.props
            .backupAllApplyItem(id)
            .then((res) => {
                if (res.status === 'success') {
                    this.setState({
                        onloadList: false,
                    });
                    this.props.openNotification(
                        T('backup_revoke_successs'),
                        'success',
                    );
                    this.props.history.push({
                        pathname: '/allApplyList/',
                        type: 'list',
                        onlyLookMe: onlyLookMe,
                    });
                }
            })
            .catch((err) => {
                if (err.status === 'Invalid_Status') {
                    this.props.openNotification(
                        T('all_apply_confirm_invalid_status'),
                        'danger',
                    );
                } else if (err.status === 'Unauthorized_Operation') {
                    this.props.openNotification(
                        T('all_apply_confirm_No_right_to_cancel'),
                        'danger',
                    );
                }
            });
    };

    render() {
        const {onloadList, backupOpened} = this.state;
        const {tabActive, allApplyDetailsList} = this.props;
        const applyCard = allApplyDetailsList && allApplyDetailsList.applyCard;
        const approvedCard =
            allApplyDetailsList && allApplyDetailsList.approvedCard;
        const onlyLookMe = this.props.location.state.onlyLookMe;
        return (
            <div className="all-apply-details">
                <Grid
                    className="container-max-width is-fixed ship-to-head"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="back-icon" item xs={3}>
                        <IconButton
                            color="inherit"
                            onClick={() =>
                                this.props.history.push({
                                    pathname: '/allApplyList/',
                                    type: 'list',
                                    onlyLookMe: onlyLookMe,
                                })
                            }>
                            <ArrowBackIos />
                        </IconButton>
                    </Grid>

                    <Grid className="page-title" item xs={9}>
                        <span>{T('all_apply_approval_details')}</span>
                    </Grid>
                </Grid>
                {onloadList ? (
                    <LoadingIcon className="circle-animation abnormal-load" />
                ) : (
                    <div>
                        {allApplyDetailsList &&
                        (allApplyDetailsList.status === 'APPROVED' ||
                            allApplyDetailsList.status === 'REJECT') ? (
                            <div className="all-apply-details-content">
                                <section className="content-box">
                                    <Grid
                                        container
                                        spacing={0}
                                        justify={'center'}
                                        className="all-apply-to-container">
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T('all_apply_approver')}:
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {approvedCard &&
                                                    approvedCard.approvedUser}
                                            </p>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T('all_apply_approval_time')}:
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {approvedCard &&
                                                    approvedCard.approvedTime}
                                            </p>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T(
                                                    'all_apply_actual_supply_center',
                                                )}
                                                :
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {approvedCard &&
                                                    approvedCard.approvedActualCoveredSiteName}
                                            </p>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T(
                                                    'all_apply_actual_distribution_mode',
                                                )}
                                                :
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {approvedCard &&
                                                    getTransMode[
                                                        approvedCard
                                                            .approvedActualTransportMethod
                                                    ]}
                                            </p>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T(
                                                    'all_apply_approval_comments',
                                                )}
                                                :
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {approvedCard &&
                                                    approvedCard.approvedReason}
                                            </p>
                                        </Grid>
                                    </Grid>
                                </section>
                            </div>
                        ) : null}

                        <div className="all-apply-details-content">
                            <section className="content-box">
                                <Grid
                                    container
                                    spacing={0}
                                    justify={'center'}
                                    className="all-apply-to-container">
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T('all_apply_applicant')}:
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {applyCard &&
                                                `${applyCard.applyUser}(${
                                                    getUserType[
                                                        applyCard.userType
                                                    ]
                                                })`}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T('all_apply_apply_time')}:
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {applyCard && applyCard.applyTime}
                                        </p>
                                    </Grid>
                                    {allApplyDetailsList &&
                                    allApplyDetailsList.status ===
                                        'CANCELLED' ? (
                                        <Grid
                                            item
                                            xs={12}
                                            className="all-apply-view-info">
                                            <label>
                                                {T('all_apply_cancel_time')}:
                                            </label>
                                            <p className="all-apply-details-info-right">
                                                {applyCard &&
                                                    applyCard.cancelTime}
                                            </p>
                                        </Grid>
                                    ) : null}
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>{T('shipTo')}:</label>
                                        <p className="all-apply-details-info-right">
                                            {allApplyDetailsList.shipTo}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>{T('order_subject')}:</label>
                                        <p className="all-apply-details-info-right">
                                            {allApplyDetailsList.stAlphaName}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T('all_apply_ship_to_address')}:
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {allApplyDetailsList.stAddress}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T(
                                                'all_apply_current_supply_center',
                                            )}
                                            :
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {
                                                allApplyDetailsList.stActualCoveredSiteName
                                            }
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T('all_apply_apply_supply_center')}
                                            :
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {applyCard &&
                                                applyCard.applyActualCoveredSiteName}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T(
                                                'all_apply_apply_distribution_mode',
                                            )}
                                            :
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {applyCard &&
                                                getTransMode[
                                                    applyCard
                                                        .applyActualTransportMethod
                                                ]}
                                        </p>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className="all-apply-view-info">
                                        <label>
                                            {T('all_apply_apply_reason')}:
                                        </label>
                                        <p className="all-apply-details-info-right">
                                            {applyCard && applyCard.reasons}
                                        </p>
                                    </Grid>
                                </Grid>
                            </section>
                        </div>
                        {tabActive === 0 && allApplyDetailsList.canCancel ? (
                            <div className="all-apply-card-btn">
                                <BasicButton
                                    className="new-transfer-btn"
                                    testid="withdraw-button"
                                    type="primary"
                                    isStopPropagation={true}
                                    onClickOfSingleTap={this.backupApply}>
                                    {T('backup_revoke')}
                                </BasicButton>
                            </div>
                        ) : null}
                    </div>
                )}

                <Dialog
                    dialogDidClose={this.closeDialog}
                    opened={backupOpened}
                    options={{bgClickClose: true}}>
                    <div
                        className="logout-dialog"
                        testid="apply-detail-withdraw">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>
                                    {T('all_apply_confirm_backup_title')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12}>
                                <span>{T('all_apply_confirm_backup')}</span>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    testid="confirm-button"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.cancelApply}>
                                    <span>{T('backup_revoke')}</span>
                                </BasicButton>
                                <BasicButton
                                    className="all_apply_confirm-btn-cancel"
                                    testid="cancelled-tab"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.closeDialog}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {allApply} = state;
    return {
        tabActive: allApply.tabActive,
        allApplyDetailsList: allApply.allApplyDetailsList,
    };
};

const mapDispatchToProps = {
    openNotification,
    viewAllApplyList,
    backupAllApplyItem,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AllApplyApprovalDetails);
